import classnames from "classnames/bind";
import { useId } from "react";

import { Chip } from "../../chip/chip";
import { useUiContext } from "../../ui-context/use-ui-context";
import styles from "./selected-items.module.scss";
const cx = classnames.bind(styles);

type Props<T> = {
  id: string;
  selectedItems: T[];
  disabled?: boolean;
  getItemId?: (item: T) => string;
  getDisplayName: (item: T) => string;
  onRemove: (item: T) => void;
  isRemovable?: (item: T) => boolean;
  orderChipsAlphabetical?: boolean;
};

export const SelectedItems = <T,>(props: Props<T>) => {
  const id = useId();
  const {
    selectedItems,
    disabled,
    getDisplayName,
    getItemId = () => id,
    isRemovable = () => true,
    orderChipsAlphabetical = false
  } = props;
  const { translation } = useUiContext();

  if (orderChipsAlphabetical) {
    selectedItems.sort((a, b) =>
      getDisplayName(a).localeCompare(getDisplayName(b))
    );
  }

  return (
    <>
      {selectedItems.length > 0 && (
        <ul className={cx("design-multiple-list")} id={props.id}>
          <span className="sr-only">
            {translation.autocomplete.selectedItems}
          </span>

          {selectedItems.map((item) => (
            <li key={getItemId(item)}>
              <Chip
                className={cx("design-multiple-list-chip", { disabled })}
                isRemovable={!disabled && isRemovable(item)}
                removeAriaLabel={translation.general.remove.replace(
                  "{item}",
                  getDisplayName(item)
                )}
                onRemoveClick={() => props.onRemove(item)}
              >
                {getDisplayName(item)}
              </Chip>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
